import store from '../Redux/Store/store';
import checkImageRepeatedName from './checkImageRepeatedName';
import { ImageData } from '../Redux/Actions/Atlas/images.action';

const preventImageNameDuplicate = (image: ImageData, imageAtlas?: ImageData[]) =>{
    let imageData = imageAtlas ? imageAtlas : store.getState().imagesAtlas;
    let imageCopy = image;
    let iterations = 0;
    let initialName = image.name;
    while (checkImageRepeatedName(image, imageData)) {
        iterations++;
        imageCopy.name = `${initialName}${iterations}`;
    }
    return(imageCopy.name);
}

export default preventImageNameDuplicate;